import { useIntl } from 'react-intl';

import { MugIcon } from './icons/MugIcon';

export type StoreSelectorNoResultsStrings = Record<'noResults' | 'searchSomethingElse', string>;
export interface StoreSelectorNoResultsProps {
  query: string;
}

export function StoreSelectorNoResults({ query }: StoreSelectorNoResultsProps) {
  const intl = useIntl();
  const noResults = intl.formatMessage({ id: 'venueSelector.search.noResultsForQuery' }, { query });
  const searchSomethingElse = intl.formatMessage({
    id: 'venueSelector.search.searchSomethingElse',
  });

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6">
      <div className="mt-10">
        <MugIcon />
      </div>
      <div className="flex h-full w-full max-w-full flex-col items-center justify-center gap-2 px-4">
        <span
          className="w-full max-w-full truncate text-center bolt-font-body-l-accent text-primary"
          title={query}
        >
          {noResults}
        </span>
        <span className="text-center bolt-font-body-m-regular text-secondary">
          {searchSomethingElse}
        </span>
      </div>
    </div>
  );
}
